import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_FORM_ON_COMBO_EXPERIMENT = defineFcm('promote_form_on_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Promote or Share Page',
		description: 'Promote form on combo experiment',
		import: false,
		template: {
			experimentName: '',
		},
	});
